import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { ContentCard, PageHeader } from '@/shared/ui';
import { LandingPartnerManager } from '@/widgets/landing-partner-manager';
import { LandingRecommendedManager } from '@/widgets/landing-recommended-manager';
import { LandingTestimonialManager } from '@/widgets/landing-testimonial-manager';

/**
 * 랜딩 페이지 관리 — 고객 web HOME 구성(히어로 배너·추천 상품·포트폴리오·기업 고객 사례·함께한 기업). HOME 순서대로 놓는다.
 * 히어로 배너는 배너 관리(/banners) 한곳에서만 관리한다 — 여기서는 그리로 안내만 한다.
 */
export const LandingPage = (): ReactElement => (
  <>
    <PageHeader title="랜딩 페이지" description="고객 web HOME 구성 관리" />

    <div className="flex flex-col gap-6">
      <ContentCard
        title="히어로 배너"
        description="HOME 첫 화면 배너 사진과 배너마다 보여 줄 상품은 배너 관리에서 설정합니다."
      >
        <Link to="/banners" className="inline-block text-sm font-medium underline">
          배너 관리
        </Link>
      </ContentCard>
      <LandingRecommendedManager />
      <ContentCard
        title="포트폴리오"
        description="제작 사례와 홈 노출은 포트폴리오 관리에서 설정합니다."
      >
        <Link to="/portfolio" className="inline-block text-sm font-medium underline">
          포트폴리오 관리
        </Link>
      </ContentCard>
      <LandingTestimonialManager />
      <LandingPartnerManager />
    </div>
  </>
);
